import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=4b8ab599&scoped=true"
import script from "./global-search.vue?vue&type=script&lang=js"
export * from "./global-search.vue?vue&type=script&lang=js"
import style0 from "./global-search.vue?vue&type=style&index=0&id=4b8ab599&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ab599",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8ab599')) {
      api.createRecord('4b8ab599', component.options)
    } else {
      api.reload('4b8ab599', component.options)
    }
    module.hot.accept("./global-search.vue?vue&type=template&id=4b8ab599&scoped=true", function () {
      api.rerender('4b8ab599', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/global-search.vue"
export default component.exports